export default {
  loading: false,
  data: null,
  error: null,
  me: null,
  role: null,
};
